module.exports = __webpack_public_path__ + "static/media/group.f4ca8d7d.svg";